import { useEffect } from 'react';
import { useWindowContext } from 'Context/WindowContext';

export default function usePolling(f, interval) {
  const { windowIsVisible } = useWindowContext();
  useEffect(() => {
    let intervalId;
    if (interval > 0) {
      intervalId = setInterval(() => {
        if (windowIsVisible) {
          f();
        }
      }, interval);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [interval, windowIsVisible]);
}
